// extracted by mini-css-extract-plugin
export default {"grunner-title":"ContainerTitle_grunner-title__ApNAW"};